import { Component } from '@angular/core';
import * as Chartist from 'chartist';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { DatePipe } from "@angular/common";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { default as _rollupMoment, Moment,} from 'moment';
import { FormControl } from '@angular/forms';
import {MatDatepicker} from '@angular/material/datepicker';
import { Dashboard } from '../../models/Dashboard';
import { environment } from 'environments/environment';

const moment = _rollupMoment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-kpi7-dashboard',
  templateUrl: './kpi7.component.html',
  styleUrls: ['./kpi7.component.css'],
  providers:[DatePipe,
    {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class Kpi7Component{

  date = new FormControl(moment());
  totalCartera:any=0;
  dataactual:any;
  disponible:any = 20.00;
  monedaElement : any = 1255;
  loading: boolean = false;
  disable: boolean = false;
  simbolo: any = '';
  datarandom: any={
    '202411':{
      '1255':[
        {
          dia:"1",
          cartera:19.5,
          util:1
        },{ 
          dia:"2",
          cartera:18.5,
          util:8 
        },{ 
          dia:"3",
          cartera:14.5,
          util:2 
        },{ 
          dia:"4",
          cartera:18.6,
          util:3 
        },{ 
          dia:"5",
          cartera:16.4,
          util:9 
        },{ 
          dia:"6",
          cartera:1.8,
          util:12 
        },{ 
          dia:"7",
          cartera:1.9,
          util:3 
        },{ 
          dia:"8",
          cartera:0.2,
          util:13 
        },{ 
          dia:"9",
          cartera:1.6,
          util:6 
        },{ 
          dia:"10",
          cartera:1.2,
          util:13 
        },{ 
          dia:"11",
          cartera:1.9,
          util:10 
        },{ 
          dia:"12",
          cartera:0.8,
          util:10 
        },{ 
          dia:"13",
          cartera:0.6,
          util:4 
        },{ 
          dia:"14",
          cartera:0.1,
          util:9 
        },{ 
          dia:"15",
          cartera:1.3,
          util:2 
        },{ 
          dia:"16",
          cartera:1.0,
          util:10 
        },{ 
          dia:"17",
          cartera:1.6,
          util:5 
        },{ 
          dia:"18",
          cartera:0.7,
          util:14 
        },{ 
          dia:"19",
          cartera:0.3,
          util:11 
        },{ 
          dia:"20",
          cartera:0.5,
          util:2 
        },{ 
          dia:"21",
          cartera:1.0,
          util:8 
        },{ 
          dia:"22",
          cartera:2.5,
          util:6 
        },{ 
          dia:"23",
          cartera:0.4,
          util:7 
        },{ 
          dia:"24",
          cartera:0.6,
          util:15 
        },{ 
          dia:"25",
          cartera:1.3,
          util:5 
        },{ 
          dia:"26",
          cartera:0.4,
          util:2 
        },{ 
          dia:"27",
          cartera:0.3,
          util:4 
        },{ 
          dia:"28",
          cartera:0.9,
          util:5 
        },{ 
          dia:"29",
          cartera:1.6,
          util:14 
        },{ 
          dia:"30",
          cartera:0.4,
          util:14 
        },{ 
          dia:"31",
          cartera:0.7,
          util:2 
        }],
      '1447':[{
        dia:"1",
        cartera:2.5,
        util:2,
        acum:0
      },{ 
        dia:"2",
        cartera:1.5,
        util:5 
      },{ 
        dia:"3",
        cartera:0.5,
        util:2 
      },{ 
        dia:"4",
        cartera:0.6,
        util:3 
      },{ 
        dia:"5",
        cartera:0.4,
        util:2 
      },{ 
        dia:"6",
        cartera:1.8,
        util:12 
      },{ 
        dia:"7",
        cartera:1.9,
        util:3 
      },{ 
        dia:"8",
        cartera:1.2,
        util:3 
      },{ 
        dia:"9",
        cartera:1.6,
        util:6 
      },{ 
        dia:"10",
        cartera:2,
        util:3 
      },{ 
        dia:"11",
        cartera:1.9,
        util:10 
      },{ 
        dia:"12",
        cartera:0.8,
        util:10 
      },{ 
        dia:"13",
        cartera:1.6,
        util:5 
      },{ 
        dia:"14",
        cartera:0.1,
        util:9 
      },{ 
        dia:"15",
        cartera:1.8,
        util:1 
      },{ 
        dia:"16",
        cartera:1.0,
        util:10 
      },{ 
        dia:"17",
        cartera:1.6,
        util:5 
      },{ 
        dia:"18",
        cartera:1.7,
        util:10 
      },{ 
        dia:"19",
        cartera:0.3,
        util:11 
      },{ 
        dia:"20",
        cartera:0.5,
        util:2 
      },{ 
        dia:"21",
        cartera:1.9,
        util:10 
      },{ 
        dia:"22",
        cartera:2.5,
        util:6 
      },{ 
        dia:"23",
        cartera:2.4,
        util:12 
      },{ 
        dia:"24",
        cartera:0.6,
        util:15 
      },{ 
        dia:"25",
        cartera:0.3,
        util:15 
      },{ 
        dia:"26",
        cartera:0.4,
        util:2 
      },{ 
        dia:"27",
        cartera:1.3,
        util:7 
      },{ 
        dia:"28",
        cartera:0.9,
        util:5 
      },{ 
        dia:"29",
        cartera:1.6,
        util:14 
      },{ 
        dia:"30",
        cartera:2.4,
        util:8 
      }],
    },
    '202410':{
      '1447':[
        {
          dia:"1",
          cartera:19.5,
          util:1
        },{ 
          dia:"2",
          cartera:18.5,
          util:8 
        },{ 
          dia:"3",
          cartera:14.5,
          util:2 
        },{ 
          dia:"4",
          cartera:18.6,
          util:3 
        },{ 
          dia:"5",
          cartera:16.4,
          util:9 
        },{ 
          dia:"6",
          cartera:1.8,
          util:12 
        },{ 
          dia:"7",
          cartera:1.9,
          util:3 
        },{ 
          dia:"8",
          cartera:0.2,
          util:13 
        },{ 
          dia:"9",
          cartera:1.6,
          util:6 
        },{ 
          dia:"10",
          cartera:1.2,
          util:13 
        },{ 
          dia:"11",
          cartera:1.9,
          util:10 
        },{ 
          dia:"12",
          cartera:0.8,
          util:10 
        },{ 
          dia:"13",
          cartera:0.6,
          util:4 
        },{ 
          dia:"14",
          cartera:0.1,
          util:9 
        },{ 
          dia:"15",
          cartera:1.3,
          util:2 
        },{ 
          dia:"16",
          cartera:1.0,
          util:10 
        },{ 
          dia:"17",
          cartera:1.6,
          util:5 
        },{ 
          dia:"18",
          cartera:0.7,
          util:14 
        },{ 
          dia:"19",
          cartera:0.3,
          util:11 
        },{ 
          dia:"20",
          cartera:0.5,
          util:2 
        },{ 
          dia:"21",
          cartera:1.0,
          util:8 
        },{ 
          dia:"22",
          cartera:2.5,
          util:6 
        },{ 
          dia:"23",
          cartera:0.4,
          util:7 
        },{ 
          dia:"24",
          cartera:0.6,
          util:15 
        },{ 
          dia:"25",
          cartera:1.3,
          util:5 
        },{ 
          dia:"26",
          cartera:0.4,
          util:2 
        },{ 
          dia:"27",
          cartera:0.3,
          util:4 
        },{ 
          dia:"28",
          cartera:0.9,
          util:5 
        },{ 
          dia:"29",
          cartera:1.6,
          util:14 
        },{ 
          dia:"30",
          cartera:0.4,
          util:14 
        },{ 
          dia:"31",
          cartera:0.7,
          util:2 
        }],
      '1255':[{
        dia:"1",
        cartera:2.5,
        util:2,
        acum:0
      },{ 
        dia:"2",
        cartera:1.5,
        util:5 
      },{ 
        dia:"3",
        cartera:0.5,
        util:2 
      },{ 
        dia:"4",
        cartera:0.6,
        util:3 
      },{ 
        dia:"5",
        cartera:0.4,
        util:2 
      },{ 
        dia:"6",
        cartera:1.8,
        util:12 
      },{ 
        dia:"7",
        cartera:1.9,
        util:3 
      },{ 
        dia:"8",
        cartera:1.2,
        util:3 
      },{ 
        dia:"9",
        cartera:1.6,
        util:6 
      },{ 
        dia:"10",
        cartera:2,
        util:3 
      },{ 
        dia:"11",
        cartera:1.9,
        util:10 
      },{ 
        dia:"12",
        cartera:0.8,
        util:10 
      },{ 
        dia:"13",
        cartera:1.6,
        util:5 
      },{ 
        dia:"14",
        cartera:0.1,
        util:9 
      },{ 
        dia:"15",
        cartera:1.8,
        util:1 
      },{ 
        dia:"16",
        cartera:1.0,
        util:10 
      },{ 
        dia:"17",
        cartera:1.6,
        util:5 
      },{ 
        dia:"18",
        cartera:1.7,
        util:10 
      },{ 
        dia:"19",
        cartera:0.3,
        util:11 
      },{ 
        dia:"20",
        cartera:0.5,
        util:2 
      },{ 
        dia:"21",
        cartera:1.9,
        util:10 
      },{ 
        dia:"22",
        cartera:2.5,
        util:6 
      },{ 
        dia:"23",
        cartera:2.4,
        util:12 
      },{ 
        dia:"24",
        cartera:0.6,
        util:15 
      },{ 
        dia:"25",
        cartera:0.3,
        util:15 
      },{ 
        dia:"26",
        cartera:0.4,
        util:2 
      },{ 
        dia:"27",
        cartera:1.3,
        util:7 
      },{ 
        dia:"28",
        cartera:0.9,
        util:5 
      },{ 
        dia:"29",
        cartera:1.6,
        util:14 
      },{ 
        dia:"30",
        cartera:2.4,
        util:8 
      }],
    }
     
  }
    
  ;
  constructor(private dashboardService:DashboardService,private datePipe: DatePipe) { }
  
  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);
    //this.obtenerDashboardFecha();
  }
  startAnimationForLineChart(chart){
      let seq: any, delays: any, durations: any;
      seq = 0;
      delays = 80;
      durations = 500;

      chart.on('draw', function(data) {
        if(data.type === 'line' || data.type === 'area') {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
              to: data.path.clone().stringify(),
              easing: Chartist.Svg.Easing.easeOutQuint
            }
          });
        } else if(data.type === 'point') {
              seq++;
              data.element.animate({
                opacity: {
                  begin: seq * delays,
                  dur: durations,
                  from: 0,
                  to: 1,
                  easing: 'ease'
                }
              });
          }
      });

      seq = 0;
  };
  startAnimationForBarChart(chart){
      let seq2: any, delays2: any, durations2: any;

      seq2 = 0;
      delays2 = 80;
      durations2 = 500;
      chart.on('draw', function(data) {
        if(data.type === 'bar'){
            seq2++;
            data.element.animate({
              opacity: {
                begin: seq2 * delays2,
                dur: durations2,
                from: 0,
                to: 1,
                easing: 'ease'
              }
            });
        }
      });

      seq2 = 0;
  };
  ngOnInit() {
       
      this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);

       

  }
  sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
  async getrandom(periodo,monedaElement){
    this.loading = true;
    await this.sleep(3000);
    this.loading = false;
    var datawebsiteViewsChart:any={labels: [],series:[]};
    var datawebsiteViewsChart2:any={labels: [],series:[]};
    this.dataactual = this.datarandom[periodo][monedaElement];
    this.simbolo = (this.monedaElement == 1447)? '(k)':'(k)';    
    let smb = this.simbolo;
    let serie1: any=[]
    let serie2: any=[]
    var acumtotal:any=0;
    for (let index = 0; index < this.dataactual.length; index++) { 
       this.dataactual[index].util = (this.dataactual[index].cartera/this.disponible*100);
    } 

    for (let index = 0; index < this.dataactual.length; index++) {
      acumtotal+=this.dataactual[index].cartera;
       this.dataactual[index].acum = acumtotal;
    }
    this.dataactual.forEach(element => {
      datawebsiteViewsChart.labels.push(element.dia);
      datawebsiteViewsChart2.labels.push(element.dia);
      this.totalCartera+= element.cartera;
      serie1.push(element.cartera);
      serie2.push(element.acum);
    });
    datawebsiteViewsChart.series.push(serie1);
    datawebsiteViewsChart2.series.push(serie2);
     
    

    var optionswebsiteViewsChart = {
        axisX: {
            showGrid: false
        },
        axisY: {   
          labelInterpolationFnc: function(value) {
            return Math.floor(value) + smb; 
          },
          high: 30
        },
        low: 0,
        height: 400,
        chartPadding: { top: 5, right: 5, bottom: 5, left: 20}
    };
    
    var optionswebsiteViewsChart2 = {
      axisX: {
          showGrid: false
      },
      axisY: {   
        labelInterpolationFnc: function(value) {
          return Math.floor(value) + smb; 
        },
        high: acumtotal
      },
      height: 400,
      chartPadding: { top: 5, right: 5, bottom: 5, left: 20}
  };
    var responsiveOptions: any[] = [
      
    ];
    var websiteViewsChart = new Chartist.Bar('#websiteViewsChart', datawebsiteViewsChart, optionswebsiteViewsChart, responsiveOptions);

    //start animation for the Emails Subscription Chart
    this.startAnimationForBarChart(websiteViewsChart);

    
    var websiteViewsChart2 = new Chartist.Line('#websiteViewsChart2', datawebsiteViewsChart2, optionswebsiteViewsChart2, responsiveOptions);

    //start animation for the Emails Subscription Chart
    this.startAnimationForBarChart(websiteViewsChart2);
  }
  tipoMoneda(event){
    this.monedaElement = event;
    this.getrandom(this.datePipe.transform(this.date.value._d,'yyyyMM'),this.monedaElement);
  }
}
